import { Controller } from '@hotwired/stimulus'

// "Select from filter" dropdown (Designworks pattern): toggles the checkbox
// panel and resubmits the surrounding GET form whenever a checkbox changes,
// so filters apply without a separate button.
export default class UptimeFilterController extends Controller {
  static targets = ['panel'];

  connect () {
    this.outsideClick = (event) => {
      if (!this.element.contains(event.target)) {
        this.panelTarget.classList.add('hidden')
      }
    }
    // Capture phase: the period dropdown stops propagation on its button
    // click, which would otherwise keep this panel open alongside it.
    document.addEventListener('click', this.outsideClick, true)
  }

  disconnect () {
    document.removeEventListener('click', this.outsideClick, true)
  }

  toggle () {
    this.panelTarget.classList.toggle('hidden')
  }

  apply () {
    this.element.closest('form').requestSubmit()
  }
}
